export const imageParent = "imvs6ol";
export const image = "i14pya7e";
export const imageTextStyles = "ix49mp9";
export const logos = "l2x1nh1";
export const content = "cil9lxh";
export const overlay = "onmt9jq";
export const contentParent = "c1n999xw";
export const closeStyles = "c1ocjpdq";

require("./styles.linaria.module.css!=!../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");